import { Field, Formik } from "formik";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import ProductList from "pages/_components/product/List";
import { bool } from "prop-types";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { actions as comexActions } from "reducers/comex";

import { ReactComponent as Show } from "styles/images/search.svg";
import * as i18n from "util/i18n";
import CustomData from "pages/_components/CustomData/CustomData";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "pages/_components/Drawer/Drawer";
import ContactItem from "../_components/ContactItem";
import DeleteContactForm from "../_components/DeleteContactForm";

const ComexContactDestinationPage = ({ isDesktop }) => {
    const { comexContactList, moreDestinations, fetching, pageNumber } = useSelector((state) => state.comex);
    const dispatch = useDispatch();
    const [filter, setFilter] = useState("");
    const [contactToDelete, setContactToDelete] = useState({});
    const [openDeleteForm, setOpenDeleteForm] = useState(false);

    useEffect(() => {
        dispatch(comexActions.getComexContactList());
    }, []);

    const handleSearch = (values) => {
        setFilter(values.filter);
        dispatch(comexActions.getComexContactList(values.filter));
    };

    const fetchMoreTransactions = () => {
        dispatch(comexActions.getComexContactList("", pageNumber + 1));
    };

    useEffect(() => {
        dispatch(comexActions.cleanComexContactList());
    }, []);

    const handleOpenDeleteForm = () => {
        setOpenDeleteForm(true);
    };
    const onCloseDeleteForm = () => {
        setOpenDeleteForm(false);
    };

    const handleListReload = () => {
        dispatch(comexActions.cleanComexContactList());
        dispatch(comexActions.getComexContactList());
    };

    const revealFunction = (values) => (
        <Button className="btn-only-icon" bsStyle="link" block={false} onClick={() => handleSearch(values)}>
            <Show className="svg-image" />
        </Button>
    );

    return (
        <>
            <Notification scopeToShow="contactDestinationsPage" />
            <ResponsiveHeader id="comex.contact.destination.title" backLinkTo="/comex" />
            <MainContainer showLoader={fetching}>
                <Formik initialValues={{ filter }}>
                    {({ values }) => (
                        <Form>
                            <Field
                                component={TextField}
                                name="filter"
                                type="text"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSearch(values);
                                    }
                                }}
                                inputFunctions={revealFunction(values)}
                                placeholderText={i18n.get("echecks.search.contact")}
                                hideLabel
                                variant="outlined"
                            />
                        </Form>
                    )}
                </Formik>
                {comexContactList.length > 0 ? (
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={comexContactList || []}
                        noDataText="agenda.no.results"
                        noFiltersDataText="global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                columns={isDesktop ? 4 : 1}
                                rows={isDesktop ? 2 : 1}
                                key={`contact-item-${item.idContactDestination}`}
                                renderAs="div">
                                <ContactItem
                                    contact={item}
                                    isDesktop={isDesktop}
                                    handleOpenDeleteForm={handleOpenDeleteForm}
                                    setContactToDelete={setContactToDelete}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="contacts-list text-neutral">
                                {listItem}
                                {moreDestinations && (
                                    <Button
                                        bsStyle="link"
                                        onClick={() => fetchMoreTransactions()}
                                        image="images/figma/icon/arrow.svg"
                                        label="global.showMore"
                                        className="view-more"
                                    />
                                )}
                            </GridTable>
                        )}
                    </ProductList>
                ) : (
                    <div className="box info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="contactDestination.service.noData"
                            titleTextType="I18N"
                        />
                    </div>
                )}
            </MainContainer>
            <Drawer openSidebar={openDeleteForm} onClose={onCloseDeleteForm} isFullHeight={!isDesktop}>
                <DeleteContactForm
                    contactDestination={contactToDelete}
                    isDesktop={isDesktop}
                    handleClose={onCloseDeleteForm}
                    handleListReload={handleListReload}
                />
            </Drawer>
        </>
    );
};

ComexContactDestinationPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ComexContactDestinationPage;
